// extracted by mini-css-extract-plugin
export var downloadCardWrapper = "download-card-module--download-card-wrapper--07660";
export var footerButton = "download-card-module--footer-button--803eb";
export var inner = "download-card-module--inner--79781";
export var outer = "download-card-module--outer--84f37";